import {BaseModel} from './base.model';

export class InstituteTypeModel extends BaseModel {

    name: string;

    static validate(institute: InstituteTypeModel): boolean {
        return !!(institute.name);
    }

    constructor(instituteType?: InstituteTypeModel) {
        super();
        this.name = instituteType ? instituteType.name || null : null;
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/institute-type.model.ts